import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="page-shell">
      <h1>404</h1>
      <p>That page drifted outside the archive.</p>
      <Link to="/">Return home</Link>
    </div>
  );
};

export default NotFoundPage;